// extracted by mini-css-extract-plugin
export default {"fieldSet":"CourseLevelModal_fieldSet__qCOvd"};